/*
 * @Author: your name
 * @Date: 2020-07-01 09:37:58
 * @LastEditTime: 2020-07-29 14:53:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-workspace/packages/x-project-app/src/vendor/form-schema-config/index.js
 */
import FormBuildEngine from '@/lib/ui/components/form/form-build-engine'

// TODO: 为了方便自定义，注册时需要使用命名空间隔离，namespace
import EditorConfig from './editor.config'
import WidgetConfig from './widget.config'
import ComponentConfig from './component.config'

// 注册相关配置
FormBuildEngine.getInstance().registerEditorConfigList(EditorConfig)
FormBuildEngine.getInstance().registerWidgetLayoutConfigList(WidgetConfig)

// 注册相关数据
Object.keys(ComponentConfig).forEach((key) => {
  FormBuildEngine.getInstance().registerComponentConfigObject(ComponentConfig[key])
})
